import React from 'react'

export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
    <path
      d="M9.22559 3.17429C9.78129 2.1746 11.2187 2.1746 11.7744 3.17429L18.6917 15.6255C19.2316 16.5974 18.5291 17.7916 17.4173 17.7918H3.58268C2.47091 17.7916 1.76841 16.5974 2.30827 15.6255L9.22559 3.17429ZM10.6823 3.78138C10.6029 3.63859 10.3971 3.63859 10.3177 3.78138L3.40121 16.2326C3.32414 16.3713 3.42399 16.5416 3.58268 16.5418H17.4173C17.576 16.5416 17.6759 16.3713 17.5988 16.2326L10.6823 3.78138Z"
      fill="#C21300"/>
    <path
      d="M9.875 12.1668V8.00013C9.875 7.65496 10.1548 7.37513 10.5 7.37513C10.8452 7.37513 11.125 7.65496 11.125 8.00013V12.1668C11.125 12.512 10.8452 12.7918 10.5 12.7918C10.1548 12.7918 9.875 12.512 9.875 12.1668Z"
      fill="#C21300"/>
    <path
      d="M11.3333 14.6668C11.3333 15.127 10.9602 15.5001 10.5 15.5001C10.0398 15.5001 9.66667 15.127 9.66667 14.6668C9.66667 14.2066 10.0398 13.8335 10.5 13.8335C10.9602 13.8335 11.3333 14.2066 11.3333 14.6668Z"
      fill="#C21300"/>
  </svg>
)
